
import { Component, Prop, Vue } from 'vue-property-decorator';
import {
  Workorder,
  WorkordersApi,
  PerformoSettings,
  ValidationProblemDetails
} from 'performo-api';
import { mapGetters } from 'vuex';
import CompleteOrderComponent from '@/components/orders/CompleteOrderComponent.vue';

@Component({
  components: {
    CompleteOrderComponent
  },
  computed: mapGetters({
    ordersApi: 'ordersApi',
    settings: 'settings'
  })
})
export default class CompleteSubStatusComponent extends Vue {
  private ordersApi!: WorkordersApi;
  private settings!: PerformoSettings;

  @Prop({ required: true })
  private order!: Workorder;

  @Prop({ required: false })
  private disabled!: boolean;

  private isLoading = false;

  private get buttonText() {
    if (
      this.order.orderStatus &&
      this.settings.completeSubStatuses &&
      this.settings.completeSubStatuses.includes(this.order.orderStatus)
    ) {
      return this.order.orderStatus;
    } else {
      return 'Complete';
    }
  }

  private get buttonActive() {
    if (this.order.orderStatus === 'Complete') return true;
    if (this.order.orderStatus && this.settings.completeSubStatuses) {
      return this.settings.completeSubStatuses.includes(this.order.orderStatus);
    } else return false;
  }

  private get orderStatusIsCompleteSubStatus() {
    if (this.order.orderStatus && this.settings.completeSubStatuses) {
      return this.settings.completeSubStatuses.includes(this.order.orderStatus);
    } else return false;
  }

  private async onCompletedHandler() {
    this.$emit('completed');
  }

  private onLoadingHandler(loading: boolean) {
    this.isLoading = loading;
  }

  private async onSubStatusClickHandler(requestedStatus: string) {
    if (!this.order.workorderId) return;
    this.isLoading = true;

    try {
      await this.ordersApi.setSubStatus({
        workorderSetSubStatusCommand: {
          requestedStatus: requestedStatus,
          workorderId: this.order.workorderId
        }
      });
      this.$emit('set-sub-status');
    } catch (error) {
      this.errorHandler(error as ValidationProblemDetails);
    }

    this.isLoading = false;
  }

  private async errorHandler(error: ValidationProblemDetails | Response) {
    this.$emit('error', error);
  }
}
